/**
 * Generic per-tab JSON cache over sessionStorage — read/write/try-catch
 * pattern shared by every dashboard consumer that wants to paint the last
 * known value immediately instead of a loading flash, while a fetch corrects
 * it in the background. Private browsing / a full quota just means the next
 * visit re-shows the loading state, not a functional break.
 */
export function readSessionCache<T>(key: string): T | null {
    try {
        const raw = sessionStorage.getItem(key);
        return raw ? (JSON.parse(raw) as T) : null;
    } catch {
        return null;
    }
}

export function writeSessionCache<T>(key: string, value: T) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
        // Best effort — see file header.
    }
}
